module.exports = __webpack_public_path__ + "img/discount.9e13fef3.svg";